const blogPagination = (limit, items) => ({
    loading: false,
    showingResultCount: limit,
    items: items, 
    init() {}, 
    calculateProgressBarWidth(count) {
      return (+count * 100) / parseInt(this.items) + '%';
    },
    loadMore(NextUrl) {
      this.loading = true;
      fetch(NextUrl)
        .then(response => response.text())
        .then(data => {
          let html_div = document.createElement('div');
          html_div.innerHTML = data;
  
          const button = document.querySelector('#load-more-button');

          const href = button.getAttribute('href');
          
          const url = new URL(href, window.location.origin);
          const pageValue = url.searchParams.get('page');
          

          if (pageValue && parseInt(pageValue) === parseInt(button.getAttribute('data-total-pages'))) {
            document.querySelector('#blog-pagination').style.display = 'none';
          }
  
          let html_dom = html_div.querySelector('#blog-grid').innerHTML;
  
          if (document.querySelector('#blog-grid')) {
            document.querySelector('#blog-grid').innerHTML += html_dom;
          }
  
          this.showingResultCount = document.querySelectorAll('.article-card').length;
  
          this.calculateProgressBarWidth(this.showingResultCount);
  
          if (html_div.querySelector('#blog-pagination')) {
            let pagination_dom = html_div.querySelector('#blog-pagination').innerHTML;
            if (document.querySelector('#blog-pagination')) {
              document.querySelector('#blog-pagination').innerHTML = pagination_dom;
            }
          }

        })
        .catch(error => console.error('Error:', error))
        .finally(() => {
          this.loading = false;
        });
    }
});
  
  export default blogPagination;
  
  window.addEventListener("alpine:init", () => {
    Alpine.data("blogPagination", blogPagination);
  });
  